import React from "react";
import { readOnlyValue } from "../../../attributes/lib/attribute-data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export const DisplayValue = ({ readOnly, disabled, attributeList, collection, index, onRemoveItem }) => {
    const filteredFields = Object.keys(collection).filter((key) => key !== "id");

    return (
        <div
            key={`item_${index}`}
            className="attribute-group-item selected-item"
        >
            {filteredFields.map((key) => {
                const attrData = attributeList.find(({ uuid }) => uuid === key);

                return <p key={`output_${key}`}>{readOnlyValue(collection[key], attrData.componentType)}</p>;
            })}
            {!readOnly && !disabled && (
                <button
                    className="close"
                    onClick={(e) => onRemoveItem(e, index)}
                >
                    <FontAwesomeIcon icon={faTimesCircle} />
                </button>
            )}
        </div>
    );
};
